import template from './loader.html'
import './loader.scss'

let loaderComponent = {
    template
}

export default loaderComponent



// WEBPACK FOOTER //
// ./client/app/common/loader/loader.component.js